/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'picto-profil-question-look-4': {
    width: 40,
    height: 46,
    viewBox: '0 0 40 46',
    data: '<path pid="0" class="st0" d="M19.9 42.6v2.7V42.6c-3.8 0-9.3-.3-13.6-1.5-1.2-.3-2-.7-2.6-1l7.8-17.6h2.3l-1.6 7.3 2.9.6 1.8-8H23l1.8 8 2.9-.6-1.7-7.3h2.4l7.8 17.6c-1.9.9-6.5 2.5-16.3 2.5M11.2 3.5c.3.6.7 1.3 1.3 2.1 1.2 1.6 3.5 3.5 7.4 3.5s6.2-1.9 7.4-3.5c.6-.7 1-1.5 1.3-2.1l1.7.4L28 19.5H11.8L9.5 3.9l1.7-.4zm19.7 17.3l2.7-19.1L26.5 0l-.3 1.4s-.3 1.2-1.2 2.3C23.8 5.3 22.1 6 19.9 6c-5.1 0-6.3-4.5-6.3-4.7L13.3 0 6.2 1.6 9 20.8 0 41.1l.8.7c.4.4 4.7 3.7 19.1 3.7 14.3 0 18.6-3.3 19.1-3.7l.8-.7-8.9-20.3z"/>'
  }
})
